import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getSponsors = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/sponsors', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const fetchSponsor = async (id, callback) => {
     try {
        const response = await risapi.get(`/api/sponsors/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const createSponsor = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        const response = await risapi.post('/api/sponsors', formData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const updateSponsor = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        formData.append('_method', 'put');
        const response = await risapi.post(`/api/sponsors/${data.id}`, formData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const destroySponsor = async (sponsor, callback) => {
    try {
        const response = await risapi.delete(`/api/sponsors/${sponsor.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ success: true, sponsor });
        }
    } catch (error) {
        callback(error);
    }
};
